import React, { useEffect, useRef, useState } from "react";
import { maxUploadSize } from "utils/constant";
import { useDialogHook } from "utils/customhooks";
import UploadSizeModal from "./upload-size-modal";
import AlertIconSVG from "assets/svg/alert-info-icon-sm-svg";
import CloseIconSVG from "assets/svg/close-icon";
import { useTranslation } from "react-i18next";
import PopInfo from "components/info-popup/pop-info";
import AudioDisplay from "./audio-display";
import useAudioUpload from "utils/useAudioUpload";

const FileUploadComponent = (
  {
    id = "media-upload",
    className = "absolute top-1.5 right-2 bg-modalGray py-3.5 px-5 rounded-md text-sm leading-4 font-semibold text-lightBlack",
    outsideLabel = "",
    outsideLabelClass = "text-sm font-bold text-darkerGray leading-4",
    optional = false,
    formContainer = "form-input-container",
    image_name = "",
    fileObject={},
    showPreview = true,
    preview = null,
    setPreview = () => { },
    label = "",
    placeholder = "",
    icon = null,
    onUpload = () => { },
    onEdit = () => { },
    cropOnload = false,
    errorMessage = null,
    onDelete,
    objectFit = 'contain',
    quicEdit = false,
    showPopInfo = false,
    popInfoType = "",
    showMediaHandle = ()=>{},
    isAudio = false,
    userData={},
    setItems=[],
    itemIndex=null,
    ...props
  },
  ref
) => {
  const { t } = useTranslation();
  const [fileName, setFileName] = useState(image_name);
  const [type, setType] = useState(null);
  const [error, setError] = useState(null);
  const uploadSizeModal = useDialogHook(UploadSizeModal);
  const { http } = global.services;
  const { uploadAudio, previews,progress } = useAudioUpload({
  http,
  userId: userData.user?.id,
  setItems,
  itemIndex,
});
  
  const showUploadAlert = () => {
    uploadSizeModal({}, (callback) => {
      console.log('callback', callback)
    })
  }

  const onUploadImage = (e) => {
    const file = e.target.files[0];
    const reader = new FileReader();
    reader.addEventListener(
      "load",
      function () {
        // if (file.type === 'application/pdf') {
        //   if (file.size > maxUploadSize) {
        //     return;
        //   }
        // }
        if (file.size > maxUploadSize) {
          setError(`${t('maxSize')}`);
          return;
        }

        // convert image file to base64 string
        const result = reader.result?.toString() || "";
        setPreview(result);
        setFileName(file.name); e.target.value = "";
        setType(file.type);
        if (cropOnload) {
          onEdit(result, file.type);
        }
        if(isAudio){
          uploadAudio(file,itemIndex)
        }
      },
      false
    );

    // !!!
    if (file) {
      if (file.size > maxUploadSize) {
        setError(`${t('maxSize')}`);
        return showUploadAlert()
      }

      setError(null);
      onUpload(file);
      reader.readAsDataURL(file);
    }
  };

  useEffect(() => {
    if (errorMessage) {
      setError((prev) => errorMessage)
    }
  }, [errorMessage])

  return (
    <>
    {
      quicEdit ?
      <>
        <label htmlFor={id}>
          {icon && icon}
        </label>
        <input
            ref={ref}
            type="file"
            id={id}
            name={id}
            onChange={onUploadImage}
            {...props}
          />
          {error && (
            <p className="input-error-message mt-2 -mb-1 flex">
              <AlertIconSVG /> {error}
            </p>
          )}
      </> 
      : 
      <div className={formContainer}>
        {outsideLabel && (
          <label htmlFor={outsideLabel} className={`${outsideLabelClass} flex flex-row gap-x-2 items-center`}>
            {outsideLabel}
            {optional && <span className="font-normal">{` (${t('optional')})`}</span>}
            {showPopInfo && 
            <div className="text-black font-normal">
              <PopInfo type={popInfoType} showMediaHandle={showMediaHandle} borderColor="border-darkerGray" topCss="-8.5rem"/>
            </div>} 
          </label>
        )}
        <div className={`relative w-full 4sm:flex 4sm:flex-row h-full ${outsideLabel && "mt-2"}`}>
          {/* ---- Left Section (Preview) ---- */}
          {showPreview && (
            <button
              className={`w-43 4sm:w-54 h-43 rounded-md mr-5 cursor-pointer ${preview? "": "bg-passwordGray"}`}
              onClick={(e) => {
                if(!!preview) {
                  onEdit(preview, type)
                } else {
                  /**
                   * @type {HTMLInputElement}
                   */
                  const target = e.target.parentNode.querySelector("input[type='file']");
                  target?.click();
                }
              }}
            >
              {preview && (
                <>
                  <img
                    src={preview}
                    alt="preview-upload"
                    className="relative w-full h-full rounded-md max-h-43 max-w-43"
                    style={{objectFit: objectFit }}
                  />
                  {typeof onDelete === 'function' && (
                    <button 
                      className="flex items-center justify-center absolute top-[0.5rem] left-[8.8rem] 
                                bg-red/50 hover:bg-red text-white p-1 rounded" 
                      onClick={(e) => {
                        e.stopPropagation();
                        e.preventDefault();
                        onDelete();
                        setFileName(null);
                      }
                    }>
                      <CloseIconSVG fill="white" size={14}/>
                    </button>
                  )}
                </>
              )}
            </button>
          )}
          {/* ---- Right Section ---- */}
          {

            isAudio ?
              (() => {
                const item = previews.find(item => item.index === itemIndex);
                // const item = {name:"random-acoustic-electronic-guitar-136427", progress:40, size:"2MB"};
                return item ? (
                  <AudioDisplay
                    id={itemIndex}
                    key={itemIndex}
                    name={item.name}
                    progress={progress[item?.progressId] || 0}
                    size={item.size}
                  />
                ) :   
                 <div className="w-full relative mt-2 4sm:mt-0">
                  <input
                    type="text"
                    value={fileName?fileName:fileObject?.value?.name}
                    style={{
                      paddingTop: "1rem",
                      paddingBottom: "1rem",
                      paddingRight: label ? "8rem" : "4rem",
                    }}
                    placeholder={placeholder}
                    className="w-full"
                    readOnly
                  />
                  <div className="cursor-pointer">
                    <label htmlFor={id} className={"cursor-pointer  " + className}>
                      {label}
                      {icon}
                    </label>
                    <input
                      ref={ref}
                      type="file"
                      id={id}
                      name={id}
                      onChange={onUploadImage}
                      {...props}
                    />
                    {error && (
                      <p className="input-error-message mt-2 -mb-1 flex">
                        <AlertIconSVG /> {error}
                      </p>
                    )}
                  </div>
                </div>
              })():
              <div className="w-full relative mt-2 4sm:mt-0">
                <input
                  type="text"
                  value={fileName?fileName:fileObject?.value?.name}
                  style={{
                    paddingTop: "1rem",
                    paddingBottom: "1rem",
                    paddingRight: label ? "8rem" : "4rem",
                  }}
                  placeholder={placeholder}
                  className="w-full"
                  readOnly
                />
                <div className="cursor-pointer">
                  <label htmlFor={id} className={"cursor-pointer  " + className}>
                    {label}
                    {icon}
                  </label>
                  <input
                    ref={ref}
                    type="file"
                    id={id}
                    name={id}
                    onChange={onUploadImage}
                    {...props}
                  />
                  {error && (
                    <p className="input-error-message mt-2 -mb-1 flex">
                      <AlertIconSVG /> {error}
                    </p>
                  )}
                </div>
              </div>
 
          }
          
      </div>
      </div>
    }
    </>
  );
};

const FileUpload = React.forwardRef(FileUploadComponent);

export default FileUpload;
